/* eslint-disable */

/** Blocker used to present the ATM 2.0 experience. */
export interface RetailerMapBlocker {
  explainer_screen?: RetailerMapBlockerExplainerScreen;
  map_screen?: RetailerMapBlockerMapScreen;
  search_screen?: RetailerMapBlockerSearchScreen;
}

export interface RetailerMapBlockerExplainerScreen {
  benefits?: RetailerMapBlockerExplainerScreenBenefit[];
  limits?: RetailerMapBlockerExplainerScreenLimit[];
  header_title?: string;
  help_button_text?: string;
  help_button_action?: string;
  header_image?: RetailerMapBlockerExplainerScreenHeaderImage;
}

/** The image to use as the header for the explainer sceen */
export enum RetailerMapBlockerExplainerScreenHeaderImage {
  /** GENERIC - A generic header image to use when the user has no other status */
  GENERIC = "GENERIC",
  /** PRIMARY_BANKING_ACTIVE - The header image for Primary Banking Active users */
  PRIMARY_BANKING_ACTIVE = "PRIMARY_BANKING_ACTIVE",
}

export interface RetailerMapBlockerExplainerScreenBenefit {
  button_name?: string;
  button_client_route?: string;
  description?: string;
  /** @deprecated */
  description_items?: string[];
  enabled?: boolean;
  name?: string;
  /** @deprecated */
  remaining_benefit_text?: boolean;
  highlighted_info_text?: string;
  image_url?: string;
}

export interface RetailerMapBlockerExplainerScreenLimit {
  key?: string;
  value?: string;
}

export interface RetailerMapBlockerMapScreen {
  header_title?: string;
  location_disabled_title_text?: string;
  location_disabled_detail_text?: string;
  location_disabled_settings_text?: string;
  location_disabled_ignore_text?: string;
  no_nearby_locations_title_text?: string;
  no_nearby_locations_detail_text?: string;
  no_nearby_locations_button_text?: string;
}

export interface RetailerMapBlockerSearchScreen {
  explanation_title_text?: string;
  explanation_detail_text?: string;
  placeholder_text?: string;
  recent_section_header_text?: string;
  results_section_header?: string;
}
